/**
 * AdminFreeLeadsPage — /admin/free-leads
 *
 * Full-page wrapper for the FreeLeadsPanel. Requires admin role;
 * non-admins get bounced to /dashboard.
 */
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AppShell } from '../components/Layout';
import { Button } from '../components/ui/button';
import { ArrowLeft, Gift } from 'lucide-react';
import { useAuth } from '../lib/auth-context';
import FreeLeadsPanel from '../components/admin/FreeLeadsPanel';

export default function AdminFreeLeadsPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin' && !(Array.isArray(user.admin_features) && user.admin_features.includes('free_leads'))) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AppShell>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/admin')}
          className="-ml-2 gap-1.5"
          data-testid="free-leads-back"
        >
          <ArrowLeft size={14} /> Back to admin
        </Button>
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300 px-3 py-1 text-[11px] font-mono-edge tracking-[0.16em] uppercase">
            <Gift size={12} /> Free Concierge Leads
          </div>
          <h1 className="mt-3 text-3xl font-bold text-foreground">/free giveaway requests</h1>
          <p className="text-muted-foreground mt-1">
            Every visitor who submitted the free LinkedIn makeover form. Upload the finished PDF + a note, hit
            &ldquo;Fulfil &amp; send&rdquo;, and we&rsquo;ll email the buyer directly.
          </p>
        </div>
        <FreeLeadsPanel />
      </div>
    </AppShell>
  );
}
